export const DESKTOP_HARDCODE_LINKS = {
    APPLE: 'https://apps.apple.com/US/app/id1361619409?mt=8',
    GOOGLE: 'https://play.google.com/store/apps/details?id=net.beginners.weight.loss.workout.women.yoga.go',
};

export const HELP_CENTER_LINK = 'https://yogago.welltech.com';
